import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { EntityService } from './entity.service';

export const Ng1EntityModule = angular
  .module('control-room.shared.services.entity', [])
  .factory('crEntityService', downgradeInjectable(EntityService));